import { createSelector, createSlice, PayloadAction } from '@reduxjs/toolkit'
import { RootState } from '..'

type InitialState = {
  id?: string
  title?: string
  description?: string
  closeDate?: string
  goalAmount?: string
  backgroundImageUrl?: string
}

const initialState: InitialState = {
  id: null,
  title: '',
  description: '',
  closeDate: '',
  goalAmount: '',
  backgroundImageUrl: null,
}

const groupFormSlice = createSlice({
  name: 'groupForm',
  initialState,
  reducers: {
    initializeForm: (state, action: PayloadAction<InitialState>) => {
      state.id = action.payload.id
      state.title = action.payload.title
      state.description = action.payload.description
      state.closeDate = action.payload.closeDate
      state.goalAmount = action.payload.goalAmount
      state.backgroundImageUrl = action.payload.backgroundImageUrl
    },
    clearForm: (state) => {
      state.id = null
      state.title = ''
      state.description = ''
      state.closeDate = ''
      state.goalAmount = ''
      state.backgroundImageUrl = null
    },
    setTitle: (state, action) => {
      state.title = action.payload
    },
    setDescription: (state, action) => {
      state.description = action.payload
    },
    setCloseDate: (state, action) => {
      state.closeDate = action.payload
    },
    setGoalAmount: (state, action) => {
      state.goalAmount = action.payload
    },
    setBackgroundImageUrl: (state, action) => {
      state.backgroundImageUrl = action.payload
    },
    setId: (state, action) => {
      state.id = action.payload
    },
  },
})

export const {
  setTitle,
  setDescription,
  setCloseDate,
  setGoalAmount,
  setBackgroundImageUrl,
  initializeForm,
  clearForm,
} = groupFormSlice.actions

export const selectTitle = (state: RootState) => state.groupForm.title
export const selectDescription = (state: RootState) =>
  state.groupForm.description
export const selectCloseDateAsObject = createSelector(
  (state: RootState) => state.groupForm.closeDate,
  (closeDate) => (closeDate ? new Date(closeDate) : undefined),
)
export const selectGoalAmount = (state: RootState) => state.groupForm.goalAmount
export const selectGroupForm = (state: RootState) => state.groupForm
export const selectBackgroundImageUrl = (state: RootState) =>
  state.groupForm.backgroundImageUrl

export default groupFormSlice.reducer
